<div *ngIf="entity" class="flex flex-wrap gap-4 p-4">
  <!-- Employee Card -->
  <div class="w-full md:w-[calc(33%-1rem)] xl:w-[calc(25%-1rem)] qb-detail-card qb-primary-tint p-4">
    <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Account User</div>
    <table class="qb-info-table flush">
      <tr>
        <td class="label">Salutation</td>
        <td class="value">{{ entity.empSalutation }}</td>
      </tr>
      <tr>
        <td class="label">First Name</td>
        <td class="value">{{ entity.empFirstName }}</td>
      </tr>
      <tr>
        <td class="label">Last Name</td>
        <td class="value">{{ entity.empLastName }}</td>
      </tr>
      <tr>
        <td class="label">Email</td>
        <td class="value">{{ entity.empEmail }}</td>
      </tr>
    </table>
  </div>

  <!-- Payment Card -->
  <div class="w-full md:w-[calc(33%-1rem)] xl:w-[calc(25%-1rem)] qb-detail-card qb-primary-tint p-4">
    <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Payment</div>
    <table class="qb-info-table flush">
      <tr>
        <td class="label">Prepayment Amount</td>
        <td class="value">{{ entity.prepaymentAmt | currency }}</td>
      </tr>
      <tr>
        <td class="label">Prepayment Card</td>
        <td class="value">{{ entity.prepaymentName }}</td>
      </tr>
      <tr>
        <td class="label">Prepayment Txn</td>
        <td class="value">{{ entity.prepaymentTransactionId }}</td>
      </tr>
      <tr>
        <td class="label">P-Card Name</td>
        <td class="value">{{ entity.pCardName }}</td>
      </tr>
      <tr>
        <td class="label">Manifest</td>
        <td class="value">{{ entity.manifest?.manifestName || 'None' }}</td>
      </tr>
    </table>
  </div>

  <!-- Order / Shipping Card -->
  <div class="w-full md:w-[calc(33%-1rem)] xl:w-[calc(25%-1rem)] qb-detail-card qb-primary-tint p-4">
    <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Order / Shipping</div>
    <table class="qb-info-table flush">
      <tr>
        <td class="label">Customer PO #</td>
        <td class="value">{{ entity.customerPurchaseOrderNumber }}</td>
      </tr>
      <tr>
        <td class="label">Exp. Ship Date</td>
        <td class="value">{{ entity.origExpectedShipDate | date : "MM/dd/yyyy" }}</td>
      </tr>
      <tr>
        <td class="label">Tax Rate</td>
        <td class="value">{{ entity.taxRate * 100 | number:'1.1-2' }}%</td>
      </tr>
      <tr>
        <td class="label">Discount</td>
        <td class="value">{{ entity.discountAmt | currency }}</td>
      </tr>
      <tr>
        <td class="label">Acct Pays Freight</td>
        <td class="value">{{ entity.doesAccountPayFreight ? "Yes" : "No" }}</td>
      </tr>
      <tr *ngIf="entity.doesAccountPayFreight">
        <td class="label">1st Shipment Only</td>
        <td class="value">{{ entity.shouldChargeFreightOnFirstShipmentOnly ? "Yes" : "No" }}</td>
      </tr>
      <tr>
        <td class="label">Portal Name</td>
        <td class="value">{{ entity.portalName }}</td>
      </tr>
      <tr>
        <td class="label">Invoice Delivery</td>
        <td class="value">{{ invoiceDeliveryLabel }}</td>
      </tr>
    </table>
  </div>

  <!-- Carrier Card -->
  <div class="w-full md:w-[calc(33%-1rem)] xl:w-[calc(25%-1rem)] qb-detail-card qb-primary-tint p-4">
    <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Carrier</div>
    <table class="qb-info-table flush">
      <tr>
        <td class="label">Carrier Name</td>
        <td class="value">{{ entity.carrierAccountName }}</td>
      </tr>
      <tr>
        <td class="label">Account #</td>
        <td class="value">{{ entity.carrierAccountNumber }}</td>
      </tr>
      <tr>
        <td class="label">Postal Code</td>
        <td class="value">{{ entity.carrierAccountPostalCode }}</td>
      </tr>
    </table>
  </div>
</div>

<div *ngIf="!entity">
  <div>
    <h3>No Information Found</h3>
  </div>
</div>
